"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileSidebarService = void 0;
var app_1 = require("app");
var MenuService = /** @class */ (function () {
    function MenuService(pageId) {
        var _this = this;
        this.pageId = pageId;
        this.getItems = function (apiUrl, filter) {
            if (!apiUrl) {
                Promise.reject(new Error("MenuService: apiUrl is missing"));
            }
            var queryParams = {};
            if (filter) {
                queryParams.filter = filter;
            }
            if (_this.pageId) {
                queryParams.pageId = _this.pageId;
            }
            return (0, app_1.api)(apiUrl, queryParams).then(function (response) { return response.data; });
            // .then((items) => new Promise((res) => { setTimeout(res, 1000, items); }));
        };
    }
    return MenuService;
}());
exports.default = MenuService;
var MobileSidebarHelper = /** @class */ (function () {
    function MobileSidebarHelper() {
        var _this = this;
        this.activeHeader = true;
        this.$body = $("body");
        this.$header = $(".header");
        this.getHeaderHidingStatus = function () {
            return _this.activeHeader;
        };
        this.setSidebarState = function (isOpened) {
            if (!isOpened) {
                var contentWidth = window.innerWidth - $("body").width();
                _this.activeHeader = isOpened;
                var offset = window.pageYOffset;
                _this.offset = offset;
                _this.$body.addClass("fixed").css({
                    top: -offset,
                    "padding-right": contentWidth
                });
                _this.$header.css({ "right": contentWidth });
            }
            else {
                _this.$body.removeClass("fixed").css({
                    top: "",
                    "padding-right": ""
                });
                _this.$header.css({ "right": "" });
                window.scroll(0, _this.offset);
                setTimeout(function () {
                    _this.activeHeader = isOpened;
                }, 150);
            }
        };
    }
    return MobileSidebarHelper;
}());
exports.MobileSidebarService = new MobileSidebarHelper();
